export const baseURL = 'https://battery-fly-backend.onrender.com/api/';
